<div class="p-4 bg-third-level rounded-lg">
  <div class="grid grid-cols-[1fr_auto_auto] items-center gap-x-2 gap-y-1 text-sm">
    <span>{{ shippingLabelKey() | transloco }}:</span>
    <span class="font-medium text-right" [attr.data-testid]="shippingTestId()">
      {{ subPhase().shippingDate | appDate }}
    </span>
    <span></span>

    <span>{{ submissionLabelKey() | transloco }}:</span>
    <span class="font-medium text-right" [attr.data-testid]="submissionTestId()">
      {{ subPhase().submissionDate | appDate }}
    </span>
    <span>
      @if (editable()) {
        <app-update-submission-date-button
          [currentSubmissionDate]="subPhase().submissionDate"
          (updateSubmissionDate)="onUpdateSubmissionDate($event)"
        />
      }
    </span>
  </div>
</div>
